let authRun = ($rootScope, $state, cacheService) => {
    "ngInject";
    //If errors in URL params redirect with cached params
    $rootScope.$on('$stateChangeError', function (event, toState, toParams, fromState, fromParams, error) {
            var bookingReference = cacheService.get('bookingReference');
            var language = cacheService.get('customer').language;
            $state.go(toState.name, {locale: language, bookingReference: bookingReference});
    });
};

export default authRun;


// WEBPACK FOOTER //
// ./client/app/routes/bookings/bookings.run.js